import React, { Component } from 'react'
import GridItem from '../grid-item'
import './style.sass'
import { FormattedMessage } from 'react-intl'

export default class LinksGrid extends Component {
  render() {
    const { imageMap, links } = this.props

    return (
      <div className="bg-primary py-2 mt-4">
        <div className="wrap-narrower">
          <div className="LinksGrid__Title">
            <FormattedMessage id="links.continuaANavigare" />
          </div>
          <div className="LinksGrid mt-2">
            {links.map((link, i) => (
              <GridItem
                key={i}
                link={link}
                imageMap={imageMap}
                className="LinksGrid__Item--small"
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/links-grid/index.js